import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { Popup, getLinkingModalConfig, formatTableTime } from '@helpers';
import { triggerImageUpload, getStatusFlags, buildSmallImageData, getSmallRowWidth } from '@components/search/ncFiles/helpers';
import { fullWidth, scale, width } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Image from '@v2/context/Image/context';
import Button from '@styles/buttons';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

import Time from './time';
import NCFileType from '@components/common/NCFileType';
import { connect } from 'react-redux';
import { setNcFileData } from '@reducers/details';
import { LevelSubScreen } from '@v2/pages/common/enums';
import ColorWrapper from '@styles/colors';

export default ColorWrapper(connect(({ details: { ncFileData } }) => ({ ncFileData }), { setNcFileData })((props) => {
  const { item, C, generateImageURL, isEmpty, goToDetails, ncFileData, setNcFileData, attachMode, attachImageId, effectiveWidth, isPopupMode } =
    props;

  const { isUnknown, isIgnored, isChange, isSetup, showOverlay } = getStatusFlags(item.ncFileStatus);

  if (isEmpty) {
    return null;
  }

  return (
    <View style={{ width: '100%', alignItems: 'center' }}>
      <TouchableElement onPress={() => goToDetails(item)}>
        {({ boxStyle }) => (
          <View
            style={[
              boxStyle,
              {
                height: scale(60),
              },
            ]}
          >
            <View
              style={{
                width: getSmallRowWidth(effectiveWidth, width, isPopupMode),
                flexDirection: 'row',
                flexDirection: 'row',
                alignItems: 'center',
                overflow: 'hidden',
              }}
            >
              <View style={{ width: scale(66), height: scale(44), position: 'relative', overflow: 'hidden', borderRadius: scale(6) }}>
                {isUnknown ? (
                  // Unknown status: Show addPicture placeholder (clickable with hover)
                  <TouchableElement onPress={() => triggerImageUpload(item)}>
                    {({ hovered }) => (
                      <View style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: C(hovered ? 'Button/Light/Secondary hover' : 'Background/Light/Tile No Picture'),
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <Svg icon="addPicture" color={hovered ? 'Button/Light/Primary Text' : 'Button/Light/Secondary Text'} width={scale(20)} height={scale(20)} C={C} />
                      </View>
                    )}
                  </TouchableElement>
                ) : (
                  <>
                    <Image
                      {...buildSmallImageData(item, () => goToDetails(item, LevelSubScreen.DOCUMENTS), attachMode)}
                    />
                    {showOverlay && (
                      // Ignored/Change status: Show gray overlay with text
                      <View
                        style={[
                          StyleSheet.absoluteFill,
                          {
                            backgroundColor: C('Background/Light/Field [mobile]'),
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: scale(4),
                          },
                        ]}
                      >
                        <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary'), fontSize: scale(8), textAlign: 'center' }]} numberOfLines={3}>
                          {i18n.t(`marked as ${isIgnored ? 'Ignored' : isSetup ? 'Setup' : 'Change'}${item.ncFileStatusSetBy ? ' by' : ''}...`)}
                          {item.ncFileStatusSetBy ? `\n${item.ncFileStatusSetBy}` : ''}
                          {'\n'}
                          {i18n.t('on')} {item.ncFileStatusSetOn ? formatTableTime(item.ncFileStatusSetOn) : ''}
                        </Text>
                      </View>
                    )}
                  </>
                )}
              </View>
              <View style={{ flex: 1, paddingLeft: scale(10) }}>
                <Time {...{ C, item, showName: true, showIcon: true, showStatusText: true }} />
              </View>
              {isUnknown && (
                <View style={{ paddingLeft: scale(10) }}>
                  <Button
                    {...{
                      variant: 'M',
                      type: 'Secondary',
                      onPress: () => {
                        if (ncFileData.data?.ncFileId !== item?.ncFileId) {
                          setNcFileData(item);
                        }
                        Popup({
                          Component: (p) => (
                            <NCFileType
                              {...{
                                ...p,
                                selectedItem: {
                                  machineStatus: item,
                                },
                              }}
                            />
                          ),
                          ...getLinkingModalConfig(scale, fullWidth),
                        });
                      },
                    }}
                  >
                    {i18n.t('UPDATE')}
                  </Button>
                </View>
              )}
            </View>
          </View>
        )}
      </TouchableElement>
    </View>
  );
}));
